
define('text!auth/redirect.html',[],function () { return '<h3>Authentication Redirect</h3>\r\n<p>Redirecting you now to the provider login page...</p>';});

